import ZkTable from './src/main'
ZkTable.install = function (Vue) {
  Vue.component(ZkTable.name, ZkTable)
}
export default ZkTable



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/table/index.js